import React, {useState} from "react";
import {useAppDispatch, useAppSelector} from "../../../redux/hooks";
import {Button} from "../../buttons";
import ModalBasic from "../../commons/Modals/ModalBasic";
import {defaultNotificationCreator} from "../../../templates/Notifications";
import {setTemporaryNotifications} from "../../../redux/notifications/actions";
import {tasksService} from "../../../api";

// @ts-ignore
function Stop({taskId}) {

    const dispatch = useAppDispatch();

    const [modalOpen, setModalOpen] = React.useState(false);
    
    const { sellerId, userId } = useAppSelector(({ sellers, users }) => ({
        sellerId: sellers.currentSeller.info.data?.id,
        userId: users.currentUser.data.id
    }))

    const [inProcessing, setInProcessing] = useState<boolean>(false)

    function clickHandler() {
        setInProcessing(true)
        if (!sellerId || !userId) {
            return;
        }

        tasksService.stopTask(sellerId, taskId)
            .then(
                (res) => {
                    if (res.data.success) {
                        dispatch(setTemporaryNotifications(
                            defaultNotificationCreator({
                                title: "Выполнение задачи будет прервано в ближайшее время",
                                description: "",
                                iconType: "success"
                            })
                        ))
                        setModalOpen(false)
                    }
                },
                (err) => {
                    dispatch(setTemporaryNotifications(
                        defaultNotificationCreator({
                            title: "Не удалось прервать задачу",
                            description: err.message(),
                            iconType: "warning"
                        })
                    ))
                }
            )
            .catch((err) => {
                dispatch(setTemporaryNotifications(
                    defaultNotificationCreator({
                        title: "Не удалось прервать задачу",
                        description: err.message,
                        iconType: "warning"
                    })
                ))
            })
            .finally(() => {
                setModalOpen(false)
                setInProcessing(false)
            })
    }

    function clickHandlers() {
        clickHandler();
    }
    
    return (
        <>
            <Button
            appearance="danger"
            size="sm"
            customClassName="mr-2"
            clickHandler={() => setModalOpen(true)}
            loading={inProcessing}
            >Прервать</Button>
            <ModalBasic id="confirmTaskStop" customSize="max-w-sm" title="" modalOpen={modalOpen} setModalOpen={setModalOpen}>
                <div className={`py-5`}>
                    <div className={`justify-center flex`}>Подтверждаете прерывание задачи?</div>
                    <div className={`justify-center flex mt-5`}>
                        <Button
                            appearance="primary"
                            customClassName="button-add px-[50px]"
                            clickHandler={clickHandlers}
                            loading={inProcessing}
                        >Да</Button>
                    </div>
                </div>
            </ModalBasic>
        </>

    );
}

export default Stop;
